import { ExerciseType } from './Exercise.types'
import { EnglishDialect } from '../User'
import { Exercise2Blob, ExerciseBlob } from '../Lesson'

const EXERCISE_TYPES_WITH_RECORDING = [
  ExerciseType.Conversation,
  ExerciseType.ReadSentence,
  ExerciseType.WordPractice,
  ExerciseType.ReadWordRace
]

const MINIMUM_RECORDING_DURATION_MS = 250

export const isExerciseWithRecording = (exercise: ExerciseBlob | Exercise2Blob) =>
  EXERCISE_TYPES_WITH_RECORDING.includes(exercise.type)

export const tryShowMessageOnTooShortExerciseRecording = ({
  recordingDurationMs
}: {
  recordingDurationMs: number
}): boolean => {
  const isRecordingTooShort = Boolean(recordingDurationMs && recordingDurationMs < MINIMUM_RECORDING_DURATION_MS)

  if (isRecordingTooShort) {
    // TODO-VV: Add toast notification
    // showErrorMessage("We couldn't hear what you said. Try holding the button for longer")
  }

  return isRecordingTooShort
}

export const getTextToSpeechLink = (sentence: string, englishDialect: EnglishDialect = EnglishDialect.EnUS) => {
  const country = englishDialect === EnglishDialect.EnGB ? 'GB' : 'US'
  const url = `${process.env.REACT_APP_API_URL}/google/textToSpeech?text=${encodeURIComponent(
    sentence
  )}&country=${country}`
  return url
}

export const getUniqueEntities = <T extends { _id?: string; productId?: string }>(
  previousEntities: T[],
  newEntities: T[]
): T[] => {
  const filteredPreviousEntities = previousEntities.filter(
    (previousEntity) =>
      newEntities.find(
        (newEntity) => newEntity._id === previousEntity._id || newEntity.productId === previousEntity.productId
      ) === undefined
  )

  return [...filteredPreviousEntities, ...newEntities]
}
